import "./rank-stars.css";

export const createRankStars = () => {};
